// severity: 'debug' should generally be filtered and not displayed in the UI

export const LOGIN_SUCCESS = { text: 'Login success', severity: 'success' }
export const LOGIN_FAILED = { text: 'Login failed', severity: 'error' }

export const AUTO_LOGIN_SUCCESS = { text: 'Auto-login success', severity: 'debug' }
export const AUTO_LOGIN_FAILED = { text: 'Auto-login failed', severity: 'error' }

export const SET_PROJECT_IDENTIFIERS_SUCCESS = { text: 'Set project identifiers success', severity: 'debug' }
export const SET_PROJECT_IDENTIFIERS_FAILED = { text: 'Set project identifiers failed', severity: 'error' }

export const PROJECT_CREATE_SUCCESS = { text: 'Project created', severity: 'success' }
export const PROJECT_LOAD_SUCCESS = { text: 'Project loaded', severity: 'success' }
export const PROJECT_CREATE_OR_LOAD_FAILED = { text: 'Project create/load failed', severity: 'error' }

export const SDK_BOOT_FAILED = { text: 'SDK Boot failed', severity: 'error' }
